import { FormattedMessage } from '@alltrails/shared/react-intl';

/*
  Returns free-trial duration text for the Plus page.
  couponTrialDuration will be either "x month(s)", "x week(s)" or "x day(s)". 
  We need to handle singular & plural month/week/day text which requires separate translations.
*/

export default (couponTrialDuration?: string) => {
  if (couponTrialDuration) {
    const durationData = couponTrialDuration.split(' ');
    const durationNum = Number(durationData[0]);
    const durationType = durationData[1];

    if (durationType.includes('month')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first month’s on us" />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} months are on us" values={{ durationNum }} />;
      }
    }

    if (durationType.includes('week')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first week’s on us" />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} weeks are on us" values={{ durationNum }} />;
      }
    }

    if (durationType.includes('day')) {
      if (durationNum === 1) {
        return <FormattedMessage defaultMessage="Your first day’s on us" />;
      }

      if (durationNum > 1) {
        return <FormattedMessage defaultMessage="Your first {durationNum} days are on us" values={{ durationNum }} />;
      }
    }
  }

  return <FormattedMessage defaultMessage="Your first week’s on us" />;
};
